import {
    EmailAuthProvider,
    reauthenticateWithCredential,
    updatePassword,
} from 'firebase/auth';
import { auth } from '../firebase';

export const ChangePassword: (
    oldPassword: string,
    newPassword: string,
) => Promise<void> = async (oldPassword, newPassword) => {
    const currentUser = auth.currentUser;

    if (!currentUser) {
        throw Error('Uživatel není správně přihlášený');
    }

    const currentEmail = currentUser.email;

    if (!currentEmail) {
        throw Error('Uživatel není správně přihlášený');
    }

    const credential = EmailAuthProvider.credential(currentEmail, oldPassword);

    try {
        await reauthenticateWithCredential(currentUser, credential);
    } catch (err: any) {
        if (err.code === 'auth/wrong-password') {
            throw Error('Aktuální heslo je nesprávné');
        } else {
            throw Error(
                'Heslo aktuálně nejde změnit. Zkuste to prosím později.',
            );
        }
    }

    try {
        await updatePassword(currentUser, newPassword);
    } catch (err) {
        throw Error(
            `Nepodařilo se změnit heslo. Zkuste to za chvíli, případně kontaktujte správce. ${err}`,
        );
    }

    return;
};
